<template>
  <div class="wrapper" @click="emitIconClick">
    <router-link v-if="to" :to="to" active-class="mobile-active">
      <IconWithText :to="to" :text="text" :icon="icon" />
    </router-link>
    <div v-else>
      <IconWithText :text="text" :icon="icon" />
    </div>
  </div>
</template>

<script>
import IconWithText from "./IconWithText";

export default {
  name: "MobileIcon",
  components: {
    IconWithText,
  },
  props: {
    to: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitIconClick() {
      this.$emit("iconClick", this.icon);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  border-radius: 15%;
  text-align: center;
  font-family: "Nunito Sans";
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  background-color: lighten($color: lightgray, $amount: 14);
  font-size: 12px;

  a:hover {
    text-decoration: none;
  }
}
</style>
